import InterestType from "@/models/Products/InterestType";

export default (interestCalulationType: InterestType) => {
    let returnVal = "Undefined";
    switch (interestCalulationType) {
        case InterestType.Simple:
            returnVal = "Simple"
            break;
        case InterestType.Compound:
            returnVal = "Compound"
            break;
    }
    return returnVal;
}